
import { useMutation } from 'react-query';

/* eslint-disable max-len */

/**
 *
 * @param {string} hostDomain
 * @returns {import('react-query').UseMutationResult<EHersEnrollResponse, Error, {email: string, zipCode: string, encAccountId: string, encServiceLocationId: string, encExternalAccountId: string}>}
 */
const usePostEnrollment = function usePostEnrollment(hostDomain) {
  const url = `${hostDomain}/api/ehers-enroll`;

  return useMutation(
    {
      mutationFn: async ({
        email, zipCode, encAccountId, encServiceLocationId, encExternalAccountId,
      }) => {
        const response = await fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            email, zipCode, encAccountId, encServiceLocationId, encExternalAccountId,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        return response.json();
      },
    },
  );
};

export default usePostEnrollment;
